import React from 'react';
import { Image } from 'antd';
import FallBackImage from '../assets/icons/noimage.png';

export default function ReactImage({ src, width, className, ...props }) {
	const prefix = process.env.REACT_APP_PUBLIC_CDN;

	return <Image src={`${prefix}/${src}`} width={width} className={className} fallback={FallBackImage} {...props} />;
}
